import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'i18n';

function WebGLWarningComponent() {
  return (
    <WebGLNotSupportedStyled>
      <FormattedMessage
        id={`mapbox.component.unavailable.text`}
        description={'WebGL is not supported by this browser'}
        defaultMessage={'WebGL is not supported by this browser'}
      />
    </WebGLNotSupportedStyled>
  );
}

const WebGLNotSupportedStyled = styled.div`
  text-align: center;
  vertical-align: center;
  padding: 32px;
  font-weight: 900;
`;

export default WebGLWarningComponent;
